export default __webpack_public_path__ + "static/media/Confetti.38e08f53.svg";